<div class="actions-container">
  <span [matTooltip]="isUserSharingToGroup() ? 'End your screen share to enable this option.' : ''">
    @if (showPresentOption() && isConnectedRoom() && crossRoomPresentationEnabled()) {
      <button
        id="btnStartPresentationAll"
        data-testid="button-quick-present-all"
        class="action-item"
        matRipple
        (click)="handleQuickPresent(true)"
        [class.disabled]="!canStartSocialEvent() || isUserSharingToGroup()"
        [disabled]="isSomeoneElsePresenting()"
      >
        Present to All Rooms
      </button>
    }
  </span>
  <span [matTooltip]="isUserSharingToGroup() ? 'End your screen share to enable this option.' : ''">
    @if (showPresentOption()) {
      <button
        id="btnStartPresentation"
        data-testid="button-quick-present"
        class="action-item"
        matRipple
        (click)="handleQuickPresent()"
        [class.disabled]="!canStartSocialEvent() || isUserSharingToGroup()"
      >
        Present to Room
      </button>
    }
  </span>
  <span [matTooltip]="isUserSharingToGroup() ? 'End your screen share to enable this option.' : ''">
    @if (showJoinOption()) {
      <button
        id="btnPresent"
        data-testid="button-present"
        class="action-item"
        matRipple
        (click)="handleQuickJoinPresentation()"
        [class.disabled]="isPresentationFull() || isUserSharingToGroup()"
      >
        Join Presentation
      </button>
    }
  </span>
  <span [matTooltip]="isUserSharingToGroup() ? 'End your screen share to enable this option.' : ''">
    @if (userCanScreenShare()) {
      <button
        id="btnShareScreen"
        data-testid="button-share-screen"
        class="action-item"
        matRipple
        (click)="handleQuickScreenShare(false)"
        [class.disabled]="isScreenShareActive() || isUserSharingToGroup()"
      >
        Share Screen
      </button>
    }
  </span>
  <span [matTooltip]="isUserSharingToGroup() ? 'End your screen share to enable this option.' : ''">
    @if (userCanScreenShare() && enhancedScreenShare()) {
      <button
        id="btnShareScreenEnhanced"
        data-testid="button-share-screen-enhanced"
        class="action-item"
        matRipple
        (click)="handleQuickScreenShare(true)"
        [class.disabled]="isScreenShareActive() || isUserSharingToGroup()"
      >
        Share Screen for Video
      </button>
    }
  </span>
  @if (userCanGroupScreenShare()) {
    <button
      id="btnGroupShareScreen"
      data-testid="button-group-share-screen"
      class="action-item"
      matRipple
      (click)="handleQuickGroupScreenShare(false)"
      [class.disabled]="isEventActive()"
    >
      {{ groupShareButtonText() }}
    </button>
  }
  @if (userCanGroupScreenShare() && enhancedScreenShare()) {
    <button
      id="btnGroupShareScreenEnhanced"
      data-testid="button-group-share-screen-enhanced"
      class="action-item"
      matRipple
      (click)="handleQuickGroupScreenShare(true)"
      [class.disabled]="isEventActive()"
    >
      {{ groupShareButtonEnhancedText() }}
    </button>
  }
  <!-- Record Presentation -->
  <span
    [matTooltip]="
      isWideRecording()
        ? 'Meeting wide recording in progress. Recording cannot be turned off at this time.'
        : !presentationRecorderService.isRecordingOptionRegionEnabled()
          ? 'Recording is not currently supported in this region.'
          : ''
    "
  >
    @if (presentationRecorderService.isRecordingOptionVisible() && isPresentationActive()) {
      <button
        id="btnRecordPresentation"
        data-testid="button-record-presentation"
        class="action-item"
        matRipple
        (click)="presentationRecorderService.handleRecordPresentation()"
        [class.disabled]="
          !isPresentationActive() || !presentationRecorderService.isRecordingOptionRegionEnabled() || isWideRecording()
        "
      >
        {{ !presentationRecorderService.isRecording() || isWideRecording() ? 'Record Presentation' : 'End Recording' }}
      </button>
    }
  </span>

  <!-- Record Group Share -->
  <span
    [matTooltip]="
      !groupShareScreenRecorderService.isRecordingOptionRegionEnabled()
        ? 'Recording is not currently supported in this region.'
        : ''
    "
  >
    @if (groupShareScreenRecorderService.showGroupShareRecordingOption()) {
      <button
        id="btnRecordGroupSharePresentation"
        data-testid="button-record-group-share"
        class="action-item"
        matRipple
        (click)="groupShareScreenRecorderService.handleRecordGroupShare()"
        [class.disabled]="!groupShareScreenRecorderService.isRecordingOptionRegionEnabled()"
      >
        {{ !groupShareScreenRecorderService.isGroupShareRecording ? 'Record Screen Share' : 'End Screen Recording' }}
      </button>
    }
  </span>

  <span [matTooltip]="isUserSharingToGroup() ? 'End your screen share to enable this option.' : ''">
    @if (this.isHost() || this.isPresenter()) {
      <button
        id="btnJoinPresentation"
        data-testid="button-join-presentation"
        class="action-item"
        matRipple
        (click)="handleJoinPresentation()"
        [class.disabled]="disableSelectPresenters()"
      >
        Select Presenters
      </button>
    }
  </span>

  @if (itemEditor()) {
    <span>
      <button
        type="button"
        id="btnFileLibrary"
        data-testid="button-file-library"
        class="action-item"
        matRipple
        (click)="viewFileLibrary()"
      >
        View File Library
        <submenu-icon></submenu-icon>
      </button>
    </span>
  }

  <!-- TODO: Manage Presenters option when in progress and userCanManagePresenters -->

  @if (this.isPresentationActive() && (this.isPresenter() || this.isHost())) {
    <button
      id="btnOpenPresentationSettings"
      data-testid="button-open-presentation-settings"
      class="action-item"
      matRipple
      (click)="showPresentationSettings()"
    >
      Presenter Settings
      <submenu-icon></submenu-icon>
    </button>
  }
  <span [matTooltip]="isUserSharingToGroup() ? 'End your screen share to enable this option.' : ''">
    @if (showToast() && allowToast() && !canEndToast()) {
      <button
        id="btnMakeAToast"
        data-testid="start-toast-button"
        class="action-item"
        matRipple
        (click)="handleToast()"
        [class.disabled]="!canStartSocialEvent() || isUserSharingToGroup()"
      >
        Make a Toast
      </button>
    }
  </span>
  @if (showToast() && allowToast() && canEndToast()) {
    <button id="btnEndToast" data-testid="end-toast-button" class="action-item" matRipple (click)="handleEndToast()">
      End Toast
    </button>
  }
  <span [matTooltip]="isUserSharingToGroup() ? 'End your screen share to enable this option.' : ''">
    @if (showConvo() && allowConvo()) {
      <button
        id="btnStartAConvo"
        class="action-item"
        data-testid="button-start-convo"
        matRipple
        (click)="handleConvo()"
        [class.disabled]="!canStartSocialEvent() || isUserSharingToGroup()"
      >
        Start an Ice Breaker
      </button>
    }
  </span>

  <button id="btnGuests" data-testid="button-show-guests" class="action-item" matRipple (click)="showGuests()">
    Guests
    @if (isHost() && social()?.hostAdmitted && waitingListCount() > 0) {
      <span class="waiting-button">
        <span class="waiting-text">{{ waitingListCount() }} </span>
      </span>
    }
    <submenu-icon></submenu-icon>
  </button>

  <button class="action-item" data-testid="button-view-chat" matRipple (click)="showChat()">
    Chat
    <submenu-icon></submenu-icon>
  </button>

  @if (inRoomSettingsMenuEnabled()) {
    <button
      id="btnOpenRoomSettings"
      data-testid="button-open-room-settings"
      class="action-item"
      matRipple
      (click)="showRoomSettings()"
    >
      Room Settings
      <submenu-icon></submenu-icon>
    </button>
  }

  @if (this.showPlaylist() && (this.isHost() || this.allowAnyoneChangeMusic())) {
    <button
      id="btnMusicPlaylist"
      data-testid="change-room-music"
      class="action-item"
      matRipple
      (click)="handleMusicPlaylist()"
    >
      Room Music
    </button>
  }

  @if (showShareLink() && allowShareLink()) {
    <button id="btnShareLink" class="action-item" matRipple (click)="handleShareLink()">Copy Invite</button>
  }

  @if (areVideoEffectsEnabled()) {
    <div class="flex">
      <button
        id="btn-video-effects"
        data-testid="btn-video-effects"
        class="action-item"
        matRipple
        (click)="handleVideoEffectsClick()"
        [class.disabled]="!isVideoEnabled()"
      >
        Video Effects
      </button>
    </div>
  }

  @if (showSmartBadging() && smartBadgingHasQuestions()) {
    <div class="flex">
      <button
        id="btn-edit-smart-badge"
        data-testid="btn-edit-smart-badge"
        class="action-item"
        matRipple
        (click)="editSmartBadge()"
      >
        Edit Smart Badge
      </button>
    </div>
  }
</div>
